import * as React from 'react';
import _ from 'lodash';

import { SuperAgentLevelViewContainer } from '../SuperAgentLevelViewContainer';
import { IAgentCardModerationInfo } from '../../../types/agentCard';

export const getSuperAgentBadge = (moderationInfo: IAgentCardModerationInfo | null) => {
  const showSuperAgent = _.get(moderationInfo, 'qualityLevelInfo.showSuperAgent', null);
  const levelName = _.get(moderationInfo, 'qualityLevelInfo.levelName', '');

  if (!showSuperAgent) {
    return null;
  }

  return <SuperAgentLevelViewContainer levelName={levelName} />;
};
